import nav from './nav_private';
import nav_public from './nav.json';
import hero from './hero.json';
import pricing from './pricing.json';
import auth from './auth.json';
import features from './features.json';
import howItWorks from './howItWorks.json';
import testimonials from './testimonials.json';
import cta from './cta.json';
import footer from './footer.json';
import contact from './contact.json';
import menu from './menu';
import profile from './profile';
import subscription from './subscription';
import dashboard from './dashboard.json';
import faq from './faq.json';
import legal from './legal.json';
import security from './security.json';
import socialProof from './socialProof.json';
import outcome from './outcome.json';
import anywhere from './anywhere.json';
import billing from './billing.json';
import business from './business.json';
import drafts from './drafts.json';
import library from './library.json';
import welcome from './welcome.json';
import common from './common.json';
import errors from './errors.json';
import phase1 from './phase1.json';
import calendar from './calendar.json';
import onboarding from './onboarding.json';
import workspace from './workspace.json';
import planning from './planning.json';

export default {
    app: common.app,
    nav,
    nav_public,
    hero,
    pricing,
    auth,
    features,
    howItWorks,
    testimonials,
    cta,
    footer,
    contact,
    menu,
    profile,
    subscription,
    dashboard,
    faq,
    legal,
    security,
    socialProof,
    outcome,
    anywhere,
    billing,
    business,
    drafts,
    library,
    welcome,
    common,
    errors,
    phase1,
    calendar,
    onboarding,
    workspace,
    planning,
};
